import React from 'react';

interface SessionWarningDialogProps {
    open: boolean;
    countdown: number;
    inactiveDuration: number;
    onContinue: () => void;
    onLogout: () => void;
}

export function SessionWarningDialog({
    open,
    countdown,
    inactiveDuration,
    onContinue,
    onLogout,
}: SessionWarningDialogProps) {
    if (!open) return null;

    // Formatting seconds into MM:SS for countdown
    const minutes = Math.floor(countdown / 60);
    const seconds = countdown % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    // Formatting inactive duration into human readable string
    const formatInactiveTime = (totalSeconds: number) => {
        if (!totalSeconds || totalSeconds <= 0) return 'một khoảng thời gian';
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        
        const parts = [];
        if (h > 0) parts.push(`${h} giờ`);
        if (m > 0) parts.push(`${m} phút`);
        if (s > 0 || parts.length === 0) parts.push(`${s} giây`);
        
        return parts.join(' ');
    };

    const inactiveText = formatInactiveTime(inactiveDuration);

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center transform transition-all scale-100">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                    <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">
                    Phiên Đăng Nhập Sắp Hết Hạn
                </h3>
                
                <div className="mt-2 mb-6">
                    <p className="text-sm text-gray-500">
                        Bạn đã không tương tác với hệ thống trong <span className="font-semibold text-gray-700">{inactiveText}</span>. Phiên đăng nhập của bạn sẽ tự động kết thúc sau:
                    </p>
                    <div className="mt-3 text-3xl font-bold text-red-600">
                        {formattedTime}
                    </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
                    <button
                        type="button"
                        onClick={onLogout}
                        className="w-full sm:w-auto inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:text-sm"
                    >
                        Đăng xuất ngay
                    </button>
                    <button
                        type="button"
                        onClick={onContinue}
                        className="w-full sm:w-auto inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
                    >
                        Tiếp tục làm việc
                    </button>
                </div>
            </div>
        </div>
    );
}
